<div class="modal-box">
  <div class="box-button">
    <button
      type="button"
      class="close pull-right closeModalIcon"
      (click)="closeModal()"
      aria-label="Close"
    >
      <span class="button-close" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="icon-box">
    <img class="search-icon-image" src="/assets/icono/icon-check.svg" alt="" />
  </div>
  <div class="modal-body">
    <span class="title-modal copec-bold-20">
      Perfil añadido correctamente
    </span>
  </div>
  <div class="dialog-button">
    <mat-dialog-actions align="end">
      <button class="modal-button" cdkFocusInitial>Aceptar</button>
    </mat-dialog-actions>
  </div>
</div>
